import type { ClassTri } from '../../domain/entities/class-tri.entity';
import type { ClassTriRanking } from '../../domain/entities/class-tri-ranking.entity';
import type { ClassTriConfidence } from '../../domain/entities/class-tri-confidence.entity';
import type { ClassTriExcluded } from '../../domain/entities/class-tri-excluded.entity';
import type { ClassTriConfidenceStudent } from '../../domain/entities/class-tri-confidence-student.entity';
import type { StudentTri } from '../../domain/entities/student-try.entity';
import type { TriApiDatasource } from '../datasources/tri-api.datasource';

export class TriRepositoryImpl {
  private readonly api: TriApiDatasource;

  constructor(api: TriApiDatasource) {
    this.api = api;
  }

  async getClassTri(editionId: string, area?: string): Promise<ClassTri> {
    return this.api.getClassTri(editionId, area);
  }

  async getClassTriRanking(
    editionId: string,
    page: number,
    pageSize: number,
    area?: string,
  ): Promise<ClassTriRanking> {
    return this.api.getClassTriRanking(editionId, page, pageSize, area);
  }

  async getClassTriConfidence(
    editionId: string,
    includeExtra?: boolean,
  ): Promise<ClassTriConfidence> {
    return this.api.getClassTriConfidence(editionId, includeExtra);
  }

  async getClassTriConfidenceStudents(
    editionId: string,
    includeExtra?: boolean,
  ): Promise<{ students: ClassTriConfidenceStudent[] }> {
    return this.api.getClassTriConfidenceStudents(editionId, includeExtra);
  }

  async getClassTriExcluded(
    editionId: string,
    page: number,
    pageSize: number,
  ): Promise<ClassTriExcluded> {
    return this.api.getClassTriExcluded(editionId, page, pageSize);
  }

  async getStudentTri(
    editionId: string,
    email: string,
    area?: string,
  ): Promise<StudentTri> {
    return this.api.getStudentTri(editionId, email, area);
  }
}
